import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // side-effect: initialize i18next before App renders
import './index.css';

// Stale-chunk recovery. Pages are lazy chunks with content-hashed names, and a
// deploy replaces the whole image — so a tab opened BEFORE the deploy asks for
// a chunk that no longer exists (the SPA fallback answers it with index.html, a
// MIME error). Vite fires `vite:preloadError` for that; one reload picks up the
// new index.html. The sessionStorage stamp stops a reload loop if the failure is
// real (offline, blocked) rather than a stale deploy.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('swiftops:chunk-reload') ?? 0);
    if (Date.now() - last < 30_000) return; // reloaded just now — let the error surface
    sessionStorage.setItem('swiftops:chunk-reload', String(Date.now()));
  } catch {
    return; // no sessionStorage → can't guard the loop, so don't reload
  }
  event.preventDefault();
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
